<template>
  <vue-final-modal
    :value="visible"
    name="create-format-dialog"
    :classes="['create-format-dialog__container']"
    :styles="{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }"
    :content-class="[
      'create-format-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="onVisibleInput"
  >
    <div class="create-format-dialog-content">
      <h3>新卒フォーマットの作成</h3>
      <p>機能を利用するには、新卒フォーマットを作成する必要があります。</p>
      <p>以下のいずれかのフォーマットを作成してください：</p>

      <div class="format">
        <div class="format-block">
          <div class="flex format-block-flex">
            <a
              v-for="option in formatOptions"
              :key="option.id"
              :href="option.href"
              class="format-link"
            >
              <div class="format-link-top">
                <p class="format-link-memo">{{ option.memo }}</p>
                <img
                  :src="option.img"
                  :alt="option.alt"
                  class="format-link-img"
                />
              </div>
              <div class="format-link-bottom">
                <h4 class="format-link-h4">{{ option.title }}</h4>
                <p class="format-link-txt">{{ option.description }}</p>
              </div>
              <button class="format-btn">{{ option.buttonLabel }}</button>
            </a>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button @click="closeDialog" class="cancel-button">閉じる</button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import formatOptions from '@/utils/format-edit/createFormatOptions.json'

const visible = ref(false)

function openDialog() {
  visible.value = true
}

function closeDialog() {
  visible.value = false
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

defineExpose({ openDialog })
</script>

<!-- content-class / container は vue-final-modal 内部ノードのため scoped 外 -->
<style lang="scss">
.create-format-dialog__container {
  z-index: 10000;
}

.create-format-dialog__content.v--modal-box.v--modal {
  margin: 20px;
  width: auto !important;
  border-radius: 8px;
  padding: 20px;
  max-width: 600px;
  background: #fff;
}
</style>

<style lang="scss" scoped>
.create-format-dialog-content {
  padding: 24px;

  h3 {
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 16px;
    font-weight: bold;
    text-align: center;
  }

  p {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;
  }
}

.format {
  margin-bottom: 30px;
}

.format-block {
  margin-bottom: 20px;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.format-block-flex {
  justify-content: space-between;
}

.format-link {
  width: calc(50% - 10px);
  margin-bottom: 20px;
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &:hover {
    transform: scale(1.04);
    text-decoration: none;
    opacity: 1;
  }
}

.format-link-top {
  position: relative;
  text-align: center;
  background: #eef5e8;
  border-radius: 5px 5px 0 0;
  height: 100px;
  overflow: hidden;
}

.format-link-memo {
  position: absolute;
  display: inline-block;
  font-weight: bold;
  font-size: 10px;
  color: #e95b10;
  background: #fff;
  border: 1px solid #e95b10;
  padding: 0 10px;
  margin-right: 5px;
  border-radius: 25px;
  top: 5px;
  left: 5px;
}

.format-link-img {
  display: block;
  width: 70px;
  height: auto;
  padding-top: 15px;
  margin: 0 auto;
}

.format-link-bottom {
  background: #eef5e8;
  padding: 10px;
  height: 70px;
}

.format-link-h4 {
  font-weight: bold;
  font-size: 16px;
  color: #004d40;
  margin-top: 0;
  margin-bottom: 8px;
}

.format-link-txt {
  font-size: 12px;
  margin: 0;
}

.format-btn {
  width: 100%;
  padding: 10px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: #0f9934;
  border-radius: 0 0 5px 5px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0c8a2d;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.cancel-button {
  padding: 10px 24px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #e0e0e0;
  }
}

@media screen and (width <= 640px) {
  .format-link {
    width: 100%;
  }
}
</style>
